import QRCode from 'qrcode'
import { showErrorMessage, showSuccessMessage } from 'uiComponents/message'
import { Parkmap } from '../models'
import * as config from 'config'

const guestAppEndpoint = config.getRequired('guest-app-endpoint')

export const copyQrCodeToClipboard = async (parkMap: Parkmap, accountSlug: string) => {
    const mapUrl = `${guestAppEndpoint}${accountSlug}/parkmap/${parkMap.locationId}`
    try {
        const canvas = document.createElement('canvas')
        await QRCode.toCanvas(canvas, mapUrl, { width: 512 })
        const blob = await new Promise<Blob>((resolve, reject) => {
            canvas.toBlob((b) => (b ? resolve(b) : reject(new Error('Failed to create blob'))), 'image/png')
        })
        await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })])
        showSuccessMessage('QR code copied to clipboard', 'copy_qr_code')
    } catch {
        showErrorMessage('Failed to copy QR code to clipboard', 'copy_qr_code')
    }
}

export const copyMapUrlToClipboard = async (parkMap: Parkmap, accountSlug: string) => {
    const mapUrl = `${guestAppEndpoint}${accountSlug}/parkmap/${parkMap.locationId}`
    try {
        await navigator.clipboard.writeText(mapUrl)
        showSuccessMessage('Map URL copied to clipboard', 'copy_map_url')
    } catch {
        showErrorMessage('Failed to copy URL to clipboard', 'copy_map_url')
    }
}
